import {
  AfterViewInit,
  Component,
  effect,
  inject,
  input,
  signal,
  ViewChild
} from '@angular/core';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {User} from '../../../../models/user';
import {OrganizationService} from '../../../services/organization.service';

@Component({
  selector: 'app-admin-users-table',
  styleUrl: 'admin-users-table.component.scss',
  templateUrl: 'admin-users-table.component.html',
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule, MatIcon, MatIconButton, MatTooltip],
  standalone: true
})
export class AdminUsersTableComponent implements AfterViewInit {
  displayedColumns: string[] = ['name', 'email', 'organizations', 'impersonate'];
  dataSource: MatTableDataSource<User> = new MatTableDataSource();

  organizationService = inject(OrganizationService);

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  users = input.required<User[]>();
  searchValue = input.required<string>();

  constructor() {
    effect(() => {
      this.dataSource.data = this.users();
      this.applyFilter();
    });
    effect(() => {
      this.searchValue();
      this.applyFilter();
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.filterPredicate = ((data: User): boolean => {
      const search = this.searchValue().toLowerCase();
      if (!search) return true;
      return data.name.toLowerCase().includes(search) ||
        data.email.toLowerCase().includes(search);
    });

    if (this.paginator != null && this.sort != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  getOrgNames(user: User): string {
    return user.organizations?.map(o => o.name).join(', ') ?? '';
  }

  impersonateUser(user: User) {
    this.organizationService.startImpersonatingUser(user);
  }

  applyFilter() {
    this.dataSource.filter = this.searchValue();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
